import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

export default {
  data() {
    return {
      content: "",
      text: "",
      sendImgIcon: require("@/assets/img/im-icon/img-nor.svg"),
      sendVoiceImg: require("@/assets/img/im-icon/voice-nor.svg"),
      sendImg: require("@/assets/img/im-icon/send-nor.svg"),
      sendImgAfter: require("@/assets/img/im-icon/send-sel.svg"),
      isShowImgMsg: false,
      isShowNoMicrophone: false, //是否开启麦克风
      sendVoiceStatus: false, //点击开启发送状态
      sendVoiceplay: false, //发送语音界面
      percentage: 1,
      start: false, //开始录音
      time: 0,
      percentages: 0, //进度条
      a: false, //等待状态
    };
  },
  computed: {
    ...mapState('im', ['currentSession', 'recordAudio']),
    ...mapGetters('im', ['singleMap']),
    ...mapState('user', ['role', 'usersAuthorities']),
    times() {
      return this.recordAudio.process.duration;
    },
    isShowOcclusionLayer() {
      try {
        let chatOperators = this.usersAuthorities['fleet:messageSettings:chatOperators']
        return this.role === 'operator' && chatOperators !== 'true' && this.singleMap[this.currentSession] && this.singleMap[this.currentSession].role === 'driver'
      } catch {
        return false
      }
    }
  },
  watch: {
    times(news) {
      this.time = news;
      if (this.time >= 60) {
        this.time = 60;
        this.stopRecordAudio();
      }
      this.percentages = Math.ceil(this.time * 1.66);
    },
    percentages(news) {
      let domCircle = document.querySelector(".el-progress-circle");
      if (news >= 100) {
        this.sendVoiceplay = true;
        this.startSend()
        this.stopRecordAudio();
        this.SET_DURATION(this.time);
        domCircle.childNodes[0].childNodes[0].style.stroke = "#4066d4";
      }
    },
    start(news) {
      let domCircle = document.querySelector(".el-progress-circle");
      if (news) {
        domCircle.childNodes[0].childNodes[0].style.stroke = "#e6effc";
      }
    },
    'currentSession'() {
      this.content = '';
      this.isShowImgMsg = false;
      this.isShowNoMicrophone = false;
      this.sendVoiceStatus = false;
      this.sendVoiceplay = false;
      this.start = false;
      this.percentages = 0;
      this.time = 0;
      this.a = false;
    }
  },
  methods: {
    ...mapActions("im", [
      "sendTextMsg",
      "srollBottom",
      "sendImageMsg",
      "startRecordAudio",
      "stopRecordAudio",
      "playRecordAudio",
      "sendAudioMsg",
      "checkRecordAudioPremission",
      "addImageUnsend",
      "messageSendError",
    ]),
    ...mapMutations("im", [
      "SET_DURATION"
    ]),
    sendInfo: function (data) {
      data = data.trim();
      if (data) {
        this.sendTextMsg({
          text: data,
          to: this.currentSession,
          createtime: Date.now()
        });
      }
      this.content = "";
      this.srollBottom(true);
      this.$emit("scrollToBottom");
    },
    /**
     * ctrl + Enter
     */
    ctrlEnter(el, data) {
      this.text = data;
      let Event = el;
      if (Event.keyCode === 13 && !Event.shiftKey) {
        Event.preventDefault();
        this.sendInfo(this.text);
        return false;
      }
    },
    fileImage() {
      let fileFormat = ["png", "jpg", "bmp", "jpeg"];
      let imgFile = this.$refs.imageInput.files[0];
      if (fileFormat.findIndex(item => imgFile.type.includes(item)) === -1) {
        this.$message({
          message: "Please choose a picture in PNG/JPG/BMP format",
          type: "error",
        });
        return ;
      }
      const imgBlob = URL.createObjectURL(imgFile)
      this.sendImageMsg({
        file: this.$refs.imageInput.cloneNode(true),
        createtime: Date.now(),
        to: this.currentSession,
        blob: imgBlob,
      })
      this.$refs.imageInput.value = ''
    },
    imgOver() {
      let { sendImg } = this.$refs;
      sendImg.style.color = "#4066d4";
      this.isShowImgMsg = true;
    },
    imgLeave() {
      let { sendImg } = this.$refs;
      sendImg.style.color = "#4c556c";
      this.isShowImgMsg = false;
    },
    //发送语音
    sendVoice() {
      let that = this;
      new Promise((reslove) => {
        this.checkRecordAudioPremission().then((res) => {
          reslove(res);
        });
      }).then(function (res) {
        if (
          res.status !== undefined &&
          res.status !== null &&
          res.status === 403
        ) {
          that.isShowNoMicrophone = true;
        } else {
          that.isShowNoMicrophone = false;
          that.sendVoiceStatus = true;
        }
      });
    },
    //开启麦克风
    here() {
      this.checkRecordAudioPremission().then((res) => {
        if (res.status === 403) {
          this.$message({
            message: "Failed to open, please open manually",
            type: "error",
          });
        }
      });
    },
    //回到聊天框
    cancel() {
      this.isShowNoMicrophone = false;
      this.sendVoiceStatus = false;
      this.start = false
    },
    //切到发送语音状态
    playSendVoice() {
      this.sendVoiceplay = true;
      this.startSend();
    },
    returnPlaySendVoice() {
      this.stopRecordAudio();
      this.sendVoiceplay = false;
      this.cancel();
    },
    returnInput() {
      this.sendVoiceStatus = false;
    },
    //开始发送语音
    startSend() {
      this.start = !this.start;
      if (this.start) {
        this.startRecordAudio();
      } else {
        this.stopRecordAudio();
        this.SET_DURATION(this.time);
        if(this.percentages > 1.5) {
          this.sendAudioMsg({
            to: this.currentSession,
            createtime: Date.now(),
            blob: this.recordAudio.blob,
            duration: this.recordAudio.duration
          });
          this.srollBottom(true);
          this.$emit("scrollToBottom");
        }
      }
    },
  },
  mounted() {
    //设置动画进度背景颜色
    let domCircle = document.querySelector(".el-progress-circle");
    domCircle.style.width = "50px";
    domCircle.style.height = "50px";
    domCircle.childNodes[0].childNodes[0].style.stroke = "#e6effb";
  },
}